var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsColoredLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 50,
    viewBox: "0 0 163 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1344_4829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8082 35.101C42.821 33.47 41.4412 32.4206 39.6963 32.0551C35.8195 31.2438 31.2181 33.7469 28.1211 35.8098L30.1701 37.2995C33.8396 34.9265 37.0279 33.8881 39.182 34.3699C40.2825 34.6164 41.1342 35.256 41.7813 36.3304C42.6496 37.7675 42.6496 39.4814 41.7813 40.9185C41.0817 42.0704 40.147 42.7294 38.9165 42.926C35.1171 43.5407 29.4373 39.642 27.3081 37.8865C27.0094 37.629 20.3978 32.0496 14.8009 32.0496C14.3917 32.0496 13.9852 32.0772 13.5898 32.1409C11.6596 32.4538 10.1415 33.506 9.0769 35.2643C7.74129 37.4712 7.74129 40.1017 9.0769 42.3085C10.0641 43.9395 11.4439 44.9889 13.1888 45.3544C17.0657 46.1657 21.667 43.6626 24.7641 41.5997L22.715 40.11C19.0456 42.483 15.8572 43.5213 13.7031 43.0396C12.6026 42.7931 11.7509 42.1535 11.1038 41.0791C10.2355 39.642 10.2355 37.9281 11.1038 36.491C11.8034 35.3391 12.7381 34.6801 13.9686 34.4835C17.768 33.8688 23.4478 37.7675 25.577 39.523C25.8757 39.7805 32.4874 45.3599 38.0842 45.3599C38.4934 45.3599 38.8999 45.3322 39.2954 45.2686C41.2255 44.9557 42.7436 43.9035 43.8082 42.1452C45.1438 39.9383 45.1438 37.3078 43.8082 35.101Z",
    fill: "url(#paint0_linear_1344_4829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.669 7.02908C45.4561 5.19326 43.6864 3.81432 41.8088 4.01922C39.6685 4.25181 38.3882 6.35068 38.3882 8.24742V12.9962C37.2378 14.0955 36.0626 15.2252 34.9289 16.3854L26.3484 25.163L17.7679 16.3854C16.6341 15.2252 15.4589 14.0955 14.3085 12.9962V8.24742C14.3058 6.35345 13.0255 4.25458 10.8852 4.01922C9.00483 3.81709 7.23785 5.19326 7.02216 7.02908C6.79541 8.97565 8.28587 10.4543 9.27306 11.4345C10.1524 12.3067 11.0566 13.1706 11.936 14.0124V29.6958H14.3058V16.2857C14.9031 16.8672 15.4948 17.4542 16.0728 18.044L24.7003 26.8714C24.0034 27.6966 23.1241 28.9952 23.1186 30.3188C23.1158 31.1412 23.4393 31.8777 24.0505 32.4426C24.822 33.1597 25.6764 33.5252 26.4949 33.5252C27.1088 33.5252 27.7033 33.3203 28.2287 32.9022C29.2408 32.0964 29.7634 31.0609 29.6971 29.9837C29.6252 28.8429 28.8509 27.9181 28.284 27.2425L28.1513 27.0819C28.096 27.0154 28.0379 26.949 27.9826 26.8825L36.6184 18.0468C37.1964 17.4542 37.7909 16.8672 38.3854 16.2885V29.6985H40.7552V14.0152C41.6346 13.1762 42.5388 12.3095 43.4181 11.4373C44.4053 10.457 45.8958 8.97842 45.669 7.03185V7.02908ZM11.936 10.7256C11.6014 10.4017 11.2696 10.0749 10.9405 9.75096C10.2409 9.05595 9.28136 8.10343 9.37538 7.30597C9.43621 6.79095 9.9616 6.37283 10.5119 6.37283C10.5506 6.37283 10.5893 6.37283 10.628 6.37837C11.3995 6.46144 11.936 7.43058 11.936 8.24742V10.7284V10.7256ZM26.7549 31.0442C26.4313 31.3018 25.9806 30.9999 25.6571 30.7009C25.5133 30.568 25.4856 30.46 25.4856 30.3271C25.4856 29.8591 25.881 29.1918 26.3373 28.6103L26.4673 28.7654C26.8019 29.1641 27.3079 29.7678 27.33 30.1277C27.3549 30.5209 26.9346 30.9003 26.7521 31.0442H26.7549ZM41.7507 9.75096C41.4216 10.0777 41.0898 10.4017 40.7552 10.7256V8.24465C40.7552 7.42781 41.2917 6.45867 42.0632 6.3756C42.1019 6.37007 42.1406 6.37007 42.1793 6.37007C42.7296 6.37007 43.2578 6.79095 43.3158 7.3032C43.4098 8.10343 42.4503 9.05595 41.7507 9.74819V9.75096Z",
    fill: "url(#paint1_linear_1344_4829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4455 13.3124C28.3575 13.3124 29.9075 11.7603 29.9075 9.84564C29.9075 7.93102 28.3575 6.37891 26.4455 6.37891C24.5334 6.37891 22.9834 7.93102 22.9834 9.84564C22.9834 11.7603 24.5334 13.3124 26.4455 13.3124Z",
    fill: "url(#paint2_linear_1344_4829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9195 15.8095L63.79 22.9535H63.2729L58.207 15.8095V27.3976H55.793V12.293H58.5942L63.5716 19.3704L68.5296 12.293H71.3308V27.4004H68.9168V15.8123L68.9195 15.8095Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4287 27.3779V12.2705H77.8206V27.3779H75.4287Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3243 23.0168V12.2705H94.7384V27.3779H92.9078L84.3522 16.7175V27.3779H81.916V12.2705H83.7687L92.3243 23.0168Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.834 27.3779V12.2705H101.226V27.3779H98.834Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.445 15.8095L113.315 22.9535H112.798L107.732 15.8095V27.3976H105.318V12.293H108.12L113.097 19.3704L118.055 12.293H120.856V27.4004H118.442V15.8123L118.445 15.8095Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.561 12.293V21.1204C137.561 23.2636 136.944 24.9083 135.708 26.0519C134.472 27.1955 132.899 27.7327 130.988 27.6607C129.207 27.6164 127.722 27.0266 126.539 25.8913C125.353 24.756 124.761 23.1639 124.761 21.1232V12.2957H127.153V21.1232C127.153 22.4606 127.504 23.5045 128.209 24.2521C128.914 24.9997 129.84 25.3957 130.988 25.44C132.224 25.512 133.231 25.1631 134.005 24.3933C134.782 23.6235 135.169 22.5326 135.169 21.1232V12.2957H137.561V12.293Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.587 15.8095L149.457 22.9535H148.94L143.874 15.8095V27.3976H141.46V12.293H144.261L149.239 19.3704L154.197 12.293H156.998V27.4004H154.584V15.8123L154.587 15.8095Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5131 31.6618C60.3471 31.4236 60.1093 31.2353 59.8024 31.0997C59.4954 30.964 59.1581 30.892 58.7931 30.8864C58.3175 30.8864 57.9303 30.9806 57.6317 31.1689C57.333 31.3572 57.1837 31.6147 57.1837 31.9387C57.1837 32.2432 57.3275 32.4648 57.6151 32.606C57.9027 32.7444 58.323 32.8552 58.8705 32.9355C59.2798 32.9964 59.6309 33.0656 59.9241 33.1431C60.2172 33.2207 60.502 33.3397 60.7868 33.4948C61.0716 33.6499 61.2873 33.8631 61.4366 34.1317C61.586 34.4003 61.6606 34.7187 61.6606 35.0925C61.6606 35.5909 61.5168 36.0035 61.2292 36.3358C60.9417 36.668 60.5905 36.9006 60.1757 37.0363C59.7609 37.172 59.2964 37.2412 58.7793 37.2412C57.3552 37.2412 56.3597 36.7151 55.79 35.6601L56.6251 35.1036C57.0759 35.865 57.7976 36.2471 58.7903 36.2471C59.0945 36.2471 59.3738 36.2139 59.6254 36.1475C59.877 36.081 60.0927 35.9564 60.2752 35.7737C60.4577 35.5909 60.549 35.3639 60.549 35.0925C60.549 34.7408 60.3914 34.4806 60.0761 34.3116C59.7609 34.1427 59.3268 34.0209 58.771 33.9489C58.453 33.9101 58.1792 33.8631 57.9524 33.8105C57.7257 33.7579 57.4851 33.6803 57.2335 33.5806C56.9819 33.481 56.7772 33.3619 56.6224 33.2234C56.4675 33.085 56.3376 32.905 56.2352 32.6807C56.1329 32.4592 56.0804 32.2045 56.0804 31.9193C56.0804 31.5731 56.1606 31.2686 56.3182 31.0055C56.4758 30.7425 56.6887 30.532 56.9542 30.3797C57.2197 30.2274 57.5045 30.1139 57.8087 30.0364C58.1128 29.9588 58.4308 29.9229 58.7627 29.9229C60.0015 29.9229 60.8642 30.3133 61.3537 31.0969L60.5103 31.6645L60.5131 31.6618Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1161 31.1243H64.832V30.1191H70.5118V31.1243H68.2388V37.0803H67.1161V31.1243Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1767 37.0808H78.877L76.7616 34.6746H75.2933V37.0808H74.1816V30.1113C74.5384 30.1113 75.0776 30.1113 75.7993 30.1169C76.521 30.1196 77.0602 30.1224 77.417 30.1224C78.1857 30.1224 78.7858 30.3467 79.2199 30.7925C79.654 31.2411 79.8697 31.7755 79.8697 32.3985C79.8697 32.9495 79.7149 33.423 79.4079 33.8245C79.101 34.226 78.6254 34.4724 77.9838 34.5666L80.0605 36.8842L80.1794 37.0836L80.1767 37.0808ZM75.2905 31.1358V33.6611H77.4059C77.8428 33.6611 78.1746 33.5421 78.3986 33.3039C78.6226 33.0658 78.736 32.7695 78.736 32.4179C78.736 32.0662 78.6226 31.7727 78.3986 31.518C78.1746 31.2632 77.8456 31.1358 77.417 31.1358H75.2933H75.2905Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.094 37.0803H83.959V30.1191H89.0636V31.2018H85.0706V33.0819H88.9032V34.1147H85.0706V35.9838H89.0913V37.0775L89.094 37.0803Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2993 31.6618C97.1334 31.4236 96.8984 31.2353 96.5887 31.0997C96.2817 30.964 95.9444 30.892 95.5821 30.8864C95.1065 30.8864 94.7166 30.9806 94.4207 31.1689C94.1221 31.3572 93.9728 31.6147 93.9728 31.9387C93.9728 32.2432 94.1166 32.4648 94.4041 32.606C94.6917 32.7444 95.112 32.8552 95.6596 32.9355C96.0688 32.9964 96.42 33.0656 96.7131 33.1431C97.0035 33.2234 97.2911 33.3397 97.5759 33.4948C97.8607 33.6499 98.0764 33.8631 98.2257 34.1317C98.375 34.4003 98.4497 34.7187 98.4497 35.0925C98.4497 35.5909 98.3059 36.0035 98.0183 36.3358C97.7307 36.668 97.3795 36.9006 96.9648 37.0363C96.55 37.172 96.0854 37.2412 95.5683 37.2412C94.1442 37.2412 93.1487 36.7151 92.5791 35.6601L93.4142 35.1036C93.8649 35.865 94.5867 36.2471 95.5794 36.2471C95.8835 36.2471 96.1628 36.2139 96.4145 36.1475C96.6661 36.081 96.8818 35.9564 97.0643 35.7737C97.2468 35.5909 97.3381 35.3639 97.3381 35.0925C97.3381 34.7408 97.1804 34.4806 96.8652 34.3116C96.55 34.1427 96.1158 34.0209 95.56 33.9489C95.242 33.9101 94.9683 33.8631 94.7415 33.8105C94.5148 33.7579 94.2742 33.6803 94.0226 33.5806C93.7709 33.481 93.5663 33.3619 93.4114 33.2234C93.2566 33.085 93.1266 32.905 93.0243 32.6807C92.922 32.4592 92.8694 32.2045 92.8694 31.9193C92.8694 31.5731 92.9496 31.2686 93.1073 31.0055C93.2676 30.7397 93.4778 30.532 93.7433 30.3797C94.0087 30.2274 94.2935 30.1139 94.5977 30.0364C94.9019 29.9588 95.2199 29.9229 95.5517 29.9229C96.7905 29.9229 97.6533 30.3133 98.1427 31.0969L97.2993 31.6645V31.6618Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.476 31.6618C106.31 31.4236 106.075 31.2353 105.766 31.0997C105.459 30.964 105.121 30.892 104.759 30.8864C104.283 30.8864 103.896 30.9806 103.598 31.1689C103.299 31.3572 103.15 31.6147 103.15 31.9387C103.15 32.2432 103.293 32.4648 103.581 32.606C103.869 32.7444 104.289 32.8552 104.836 32.9355C105.246 32.9964 105.597 33.0656 105.89 33.1431C106.18 33.2234 106.471 33.3397 106.756 33.4948C107.04 33.6499 107.256 33.8631 107.405 34.1317C107.555 34.4003 107.629 34.7187 107.629 35.0925C107.629 35.5909 107.486 36.0035 107.198 36.3358C106.91 36.668 106.559 36.9006 106.144 37.0363C105.73 37.172 105.265 37.2412 104.748 37.2412C103.324 37.2412 102.328 36.7151 101.759 35.6601L102.594 35.1036C103.045 35.865 103.766 36.2471 104.759 36.2471C105.063 36.2471 105.343 36.2139 105.594 36.1475C105.846 36.081 106.061 35.9564 106.244 35.7737C106.427 35.5909 106.518 35.3639 106.518 35.0925C106.518 34.7408 106.36 34.4806 106.048 34.3116C105.732 34.1427 105.298 34.0209 104.742 33.9489C104.424 33.9101 104.151 33.8631 103.924 33.8105C103.697 33.7579 103.457 33.6803 103.205 33.5806C102.953 33.481 102.749 33.3619 102.594 33.2234C102.439 33.085 102.309 32.905 102.207 32.6807C102.104 32.4592 102.052 32.2045 102.052 31.9193C102.052 31.5731 102.132 31.2686 102.29 31.0055C102.45 30.7397 102.66 30.532 102.926 30.3797C103.191 30.2274 103.476 30.1139 103.78 30.0364C104.084 29.9588 104.402 29.9229 104.734 29.9229C105.973 29.9229 106.836 30.3133 107.325 31.0969L106.482 31.6645L106.476 31.6618Z",
    fill: "#FF6155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 32.8438H110.406V33.2536H157V32.8438Z",
    fill: "url(#paint3_linear_1344_4829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 33.9072H110.406V34.317H157V33.9072Z",
    fill: "url(#paint4_linear_1344_4829)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1344_4829",
    x1: 26.4453,
    y1: 44.1859,
    x2: 26.4453,
    y2: 5.32359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF726C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B3ADE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7394F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4181F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1D74FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#076CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1344_4829",
    x1: 26.3456,
    y1: 44.1857,
    x2: 26.3456,
    y2: 5.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF726C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B3ADE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7394F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4181F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1D74FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#076CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1344_4829",
    x1: 26.4455,
    y1: 44.1862,
    x2: 26.4455,
    y2: 5.32393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF726C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B3ADE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7394F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4181F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1D74FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#076CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1344_4829",
    x1: 110.683,
    y1: 33.0487,
    x2: 158.253,
    y2: 33.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF726C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B3ADE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7394F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4181F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1D74FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#076CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1344_4829",
    x1: 110.683,
    y1: 34.1121,
    x2: 158.253,
    y2: 34.1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF726C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFA7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B3ADE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7394F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4181F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1D74FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#076CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1344_4829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 41.5094,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsColoredLogo);
export default __webpack_public_path__ + "static/media/MsColoredLogo.5dbefc124b2c8923f404d95d97c560cd.svg";
export { ForwardRef as ReactComponent };